import Swiper from "swiper";
import StudioMapView from "./studio-map-view";
export default class StudioMap
{
  public readonly wrapper: HTMLElement; 
  public readonly swiper: Swiper
  private readonly views: StudioMapView[] = [];
  constructor(wrapper: HTMLElement, swiper: Swiper)
  {
    this.wrapper = wrapper;
    this.swiper = swiper;
    
    this.swiper.slides.forEach((slide, slideIndex) => {
      const viewId = slide.dataset.view;
      const viewSvgCircleElement = this.wrapper.querySelector('#kamera-' + viewId);
      if(viewSvgCircleElement instanceof SVGCircleElement) {
        this.views.push(new StudioMapView(this, viewSvgCircleElement, slideIndex));
      }
    })

    this.enable();
  }

  public enable(): void
  {
    this.swiper.on('slideChange', (swiper) => {
      this.updateViewFromSwiper(swiper);
    });
    this.updateViewFromSwiper(this.swiper);
  }

  private updateViewFromSwiper(swiper: Swiper): void
  {
    const swiperActiveSlideEl = swiper.slides.find(slide => {
      return Number(slide.dataset.swiperSlideIndex) == swiper.realIndex
    });
    const swiperViewId = swiperActiveSlideEl?.dataset.view;

    this.views.forEach(view => {
      view.setActive(view.id == swiperViewId);
    });
  }

  public setView(view: StudioMapView): void
  {
    const swiperTargetSlideEl = this.swiper.slides.find(slide => {
      return Number(slide.dataset.swiperSlideIndex) == view.slideIndex
    });

    if(swiperTargetSlideEl)
    {
      const slideIndex = Number(swiperTargetSlideEl.dataset.swiperSlideIndex);
      if(this.swiper.params.loop) {
        this.swiper.slideToLoop(slideIndex);
      } else {
        this.swiper.slideTo(slideIndex);
      }
    }
  }
}